import React, { lazy } from 'react';
import { RouteObject, Navigate } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const CalculatorPage = lazy(() => import('../pages/calculator/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const BlogArticlePage = lazy(() => import('../pages/blog/article'));
const SitemapPage = lazy(() => import('../pages/sitemap/page'));
const StatesPage = lazy(() => import('../pages/states/page'));
const StateDetailPage = lazy(() => import('../pages/states/detail'));
const NotFound = lazy(() => import('../pages/NotFound'));
const ForSalePage = lazy(() => import('../pages/for-sale/page'));

// Admin pages
const AdminLogin = lazy(() => import('../pages/admin/login'));
const AdminDashboard = lazy(() => import('../pages/admin/dashboard/page'));
const AdminLocations = lazy(() => import('../pages/admin/locations/page'));
const AdminBlog = lazy(() => import('../pages/admin/blog/page'));
const BlogEditor = lazy(() => import('../pages/admin/blog/editor'));
const AdminLinks = lazy(() => import('../pages/admin/links/page'));
const AdminMonetization = lazy(() => import('../pages/admin/monetization/page'));
const AdminAnalytics = lazy(() => import('../pages/admin/analytics/page'));
const AdminSEO = lazy(() => import('../pages/admin/seo/page'));
const AdminNewsletter = lazy(() => import('../pages/admin/newsletter/page'));

const routes: RouteObject[] = [
  { path: '/', element: <HomePage /> },
  { path: '/for-sale', element: <ForSalePage /> },
  { path: '/blog', element: <BlogPage /> },
  { path: '/blog/:slug', element: <BlogArticlePage /> },
  { path: '/sitemap', element: <SitemapPage /> },
  { path: '/states', element: <StatesPage /> },
  { path: '/states/:stateSlug', element: <StateDetailPage /> },

  // Admin routes
  { path: '/admin', element: <Navigate to="/admin/dashboard" replace /> },
  { path: '/admin/login', element: <AdminLogin /> },
  { path: '/admin/dashboard', element: <AdminDashboard /> },
  { path: '/admin/locations', element: <AdminLocations /> },
  { path: '/admin/blog', element: <AdminBlog /> },
  { path: '/admin/blog/new', element: <BlogEditor /> },
  { path: '/admin/blog/:id', element: <BlogEditor /> },
  { path: '/admin/links', element: <AdminLinks /> },
  { path: '/admin/monetization', element: <AdminMonetization /> },
  { path: '/admin/analytics', element: <AdminAnalytics /> },
  { path: '/admin/seo', element: <AdminSEO /> },
  { path: '/admin/newsletter', element: <AdminNewsletter /> },

  { path: '/:country', element: <CalculatorPage /> },
  { path: '/:country/:state', element: <CalculatorPage /> },
  { path: '/:country/:state/:city', element: <CalculatorPage /> },
  { path: '*', element: <NotFound /> },
];

export default routes;
